(function () {
  'use strict';

  function initBuzzDropsLiveChat() {
    var root = document.querySelector('[data-bd-live-chat]');
    if (!root || root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';

    var apiUrl = root.dataset.apiUrl || '';
    var ownerName = root.dataset.ownerName || 'Buzz Drops';
    var avatarUrl = root.dataset.avatarUrl || '';
    var launcher = root.querySelector('[data-bd-chat-launcher]');
    var panel = root.querySelector('[data-bd-chat-panel]');
    var closeButton = root.querySelector('[data-bd-chat-close]');
    var messagesElement = root.querySelector('[data-bd-chat-messages]');
    var form = root.querySelector('[data-bd-chat-form]');
    var input = root.querySelector('[data-bd-chat-input]');
    var sendButton = root.querySelector('[data-bd-chat-send]');
    var statusElement = root.querySelector('[data-bd-chat-status]');
    var unreadBadge = root.querySelector('[data-bd-chat-unread]');
    var storagePrefix = 'buzzdrops_live_chat_v2_';
    var openPollDelay = 1000;
    var closedPollDelay = 9000;
    var sessionKey = storagePrefix + 'session';
    var activeKey = storagePrefix + 'active';
    var seenKey = storagePrefix + 'seen_at';
    var pollTimer = 0;
    var socketReconnectTimer = 0;
    var socketReconnectAttempts = 0;
    var socket = null;
    var socketUrl = buildSocketUrl();
    var collisionFrame = 0;
    var isSending = false;
    var isOpen = false;
    var isActive = safeStorageGet(activeKey) === 'yes';
    var sessionId = safeStorageGet(sessionKey) || createSessionId();
    var messages = [];

    safeStorageSet(sessionKey, sessionId);
    root.dataset.sessionId = sessionId;
    root.dataset.realtime = isActive && socketUrl ? 'connecting' : 'idle';

    function safeStorageGet(key) {
      try {
        return window.localStorage ? localStorage.getItem(key) : null;
      } catch (error) {
        return null;
      }
    }

    function safeStorageSet(key, value) {
      try {
        if (window.localStorage) localStorage.setItem(key, value);
      } catch (error) {
        // The chat still works for this page when storage is unavailable.
      }
    }

    function createSessionId() {
      if (window.crypto && typeof window.crypto.randomUUID === 'function') {
        return window.crypto.randomUUID().replace(/-/g, '');
      }
      var random = Math.random().toString(36).slice(2);
      return 'bd' + Date.now().toString(36) + random;
    }

    function track(eventName, extra) {
      var payload = Object.assign({
        event: eventName,
        page_path: window.location.pathname
      }, extra || {});

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(payload);
      if (typeof window.clarity === 'function') {
        window.clarity('event', eventName);
      }
    }

    function setStatus(text, isError) {
      if (!statusElement) return;
      statusElement.textContent = text || '';
      statusElement.classList.toggle('is-error', Boolean(isError));
    }

    function formatTime(value) {
      var date = new Date(value || Date.now());
      if (Number.isNaN(date.getTime())) return '';
      try {
        return new Intl.DateTimeFormat([], {
          hour: 'numeric',
          minute: '2-digit'
        }).format(date);
      } catch (error) {
        return '';
      }
    }

    function avatar() {
      var wrapper = document.createElement('span');
      var image = document.createElement('img');
      wrapper.className = 'bd-live-chat__avatar';
      image.src = avatarUrl;
      image.alt = '';
      image.width = 80;
      image.height = 80;
      wrapper.appendChild(image);
      return wrapper;
    }

    function messageRow(message) {
      var role = message.role === 'visitor' ? 'visitor' : (message.role === 'system' ? 'system' : 'team');
      var row = document.createElement('div');
      var bubble = document.createElement('div');
      var text = document.createElement('p');
      var meta = document.createElement('span');

      row.className = 'bd-live-chat__message is-' + role;
      row.dataset.messageId = message.id || '';
      bubble.className = 'bd-live-chat__bubble';
      text.textContent = message.text || '';
      meta.className = 'bd-live-chat__meta';
      meta.textContent = role === 'team'
        ? (ownerName + (formatTime(message.createdAt) ? ' - ' + formatTime(message.createdAt) : ''))
        : formatTime(message.createdAt);

      if (role === 'team') row.appendChild(avatar());
      bubble.appendChild(text);
      bubble.appendChild(meta);
      row.appendChild(bubble);
      return row;
    }

    function renderMessages(forceScroll) {
      if (!messagesElement) return;
      var wasNearBottom = messagesElement.scrollHeight - messagesElement.scrollTop - messagesElement.clientHeight < 90;
      var fragment = document.createDocumentFragment();
      messages.forEach(function (message) {
        fragment.appendChild(messageRow(message));
      });
      messagesElement.replaceChildren(fragment);

      if (forceScroll || wasNearBottom) {
        window.requestAnimationFrame(function () {
          messagesElement.scrollTop = messagesElement.scrollHeight;
        });
      }
      updateUnread();
    }

    function latestTeamTimestamp() {
      return messages.reduce(function (latest, message) {
        if (message.role !== 'team') return latest;
        var timestamp = new Date(message.createdAt || 0).getTime();
        return Math.max(latest, Number.isNaN(timestamp) ? 0 : timestamp);
      }, 0);
    }

    function markRead() {
      var latest = latestTeamTimestamp();
      if (latest) safeStorageSet(seenKey, String(latest));
      if (unreadBadge) unreadBadge.hidden = true;
    }

    function updateUnread() {
      if (!unreadBadge) return;
      if (isOpen) {
        markRead();
        return;
      }
      var seenAt = Number(safeStorageGet(seenKey) || 0);
      var count = messages.filter(function (message) {
        return message.role === 'team' && new Date(message.createdAt || 0).getTime() > seenAt;
      }).length;
      unreadBadge.hidden = count === 0;
      unreadBadge.textContent = count > 9 ? '9+' : String(count);
    }

    function requestJson(url, options) {
      var controller = window.AbortController ? new AbortController() : null;
      var timeout = window.setTimeout(function () {
        if (controller) controller.abort();
      }, 12000);
      var requestOptions = Object.assign({
        mode: 'cors',
        credentials: 'omit',
        cache: 'no-store'
      }, options || {});
      if (controller) requestOptions.signal = controller.signal;

      return window.fetch(url, requestOptions).then(function (response) {
        return response.json().catch(function () { return {}; }).then(function (data) {
          if (!response.ok || data.ok === false) {
            throw new Error(data.error || 'Live chat request failed');
          }
          return data;
        });
      }).finally(function () {
        window.clearTimeout(timeout);
      });
    }

    function buildSocketUrl() {
      if (!apiUrl || !window.WebSocket) return '';
      try {
        var url = new URL(apiUrl, window.location.href);
        url.protocol = url.protocol === 'https:' ? 'wss:' : 'ws:';
        url.pathname = url.pathname.replace(/\/api\/live-chat\/?$/, '/api/live-chat-socket');
        url.search = '';
        return url.toString();
      } catch (error) {
        return '';
      }
    }

    function socketIsOpen() {
      return socket && socket.readyState === window.WebSocket.OPEN;
    }

    function nextPollDelay() {
      if (socketIsOpen()) return isOpen ? 15000 : 30000;
      return isOpen ? openPollDelay : closedPollDelay;
    }

    function scheduleSocketReconnect() {
      window.clearTimeout(socketReconnectTimer);
      if (!isActive || !socketUrl || document.visibilityState === 'hidden') return;
      socketReconnectAttempts += 1;
      var delay = Math.min(8000, 700 * Math.pow(1.65, Math.min(socketReconnectAttempts, 6)));
      socketReconnectTimer = window.setTimeout(connectSocket, delay);
    }

    function connectSocket() {
      if (!isActive || !socketUrl || document.visibilityState === 'hidden') return;
      if (socket && (socket.readyState === window.WebSocket.OPEN || socket.readyState === window.WebSocket.CONNECTING)) return;

      var connection;
      try {
        connection = new WebSocket(socketUrl + '?sessionId=' + encodeURIComponent(sessionId));
      } catch (error) {
        root.dataset.realtime = 'fallback';
        scheduleSocketReconnect();
        return;
      }

      socket = connection;
      root.dataset.realtime = 'connecting';
      connection.addEventListener('open', function () {
        if (socket !== connection) return;
        root.dataset.realtime = 'connected';
        socketReconnectAttempts = 0;
        window.clearTimeout(socketReconnectTimer);
        schedulePoll(nextPollDelay());
        track('live_chat_realtime_connected');
      });
      connection.addEventListener('message', function (event) {
        var data;
        try {
          data = JSON.parse(event.data || '{}');
        } catch (error) {
          return;
        }
        if (data.type !== 'history') return;
        syncMessages(data.messages, true);
        if (data.status === 'closed') {
          setStatus('This chat is closed. Send a message to reopen it.', false);
        }
        schedulePoll(nextPollDelay());
      });
      connection.addEventListener('close', function () {
        if (socket === connection) socket = null;
        root.dataset.realtime = 'fallback';
        schedulePoll(nextPollDelay());
        scheduleSocketReconnect();
      });
      connection.addEventListener('error', function () {
        try {
          connection.close();
        } catch (error) {
          // The close event schedules the fallback reconnect.
        }
      });
    }

    function syncMessages(nextMessages, forceScroll) {
      var oldTeamIds = new Set(messages.filter(function (message) {
        return message.role === 'team';
      }).map(function (message) {
        return message.id;
      }));
      var incoming = Array.isArray(nextMessages) ? nextMessages : [];
      var hasNewTeamReply = incoming.some(function (message) {
        return message.role === 'team' && !oldTeamIds.has(message.id);
      });
      messages = incoming;
      renderMessages(Boolean(forceScroll || hasNewTeamReply));
      if (hasNewTeamReply) track('live_chat_reply_received');
    }

    function fetchHistory() {
      if (!apiUrl || !isActive) return Promise.resolve();
      var url = apiUrl + '?sessionId=' + encodeURIComponent(sessionId) + '&t=' + Date.now();
      return requestJson(url).then(function (data) {
        syncMessages(data.messages, false);
        if (data.status === 'closed') {
          setStatus('This chat is closed. Send a message to reopen it.', false);
        }
      }).catch(function () {
        if (isOpen) setStatus('Reconnecting...', true);
      });
    }

    function schedulePoll(delay) {
      window.clearTimeout(pollTimer);
      if (!isActive) return;
      pollTimer = window.setTimeout(function poll() {
        if (document.visibilityState === 'hidden') {
          schedulePoll(12000);
          return;
        }
        fetchHistory().finally(function () {
          schedulePoll(nextPollDelay());
        });
      }, delay);
    }

    function openChat() {
      if (isOpen || root.classList.contains('is-suppressed')) return;
      isOpen = true;
      root.classList.add('is-open');
      document.body.classList.add('bd-live-chat-open');
      launcher.setAttribute('aria-expanded', 'true');
      panel.setAttribute('aria-hidden', 'false');
      markRead();
      renderMessages(true);
      connectSocket();
      fetchHistory().finally(function () {
        schedulePoll(nextPollDelay());
      });
      window.setTimeout(function () {
        input.focus({ preventScroll: true });
      }, 180);
      track('live_chat_open');
      scheduleCollisionUpdate();
    }

    function closeChat(restoreFocus) {
      if (!isOpen) return;
      isOpen = false;
      root.classList.remove('is-open');
      document.body.classList.remove('bd-live-chat-open');
      launcher.setAttribute('aria-expanded', 'false');
      panel.setAttribute('aria-hidden', 'true');
      schedulePoll(closedPollDelay);
      scheduleCollisionUpdate();
      if (restoreFocus !== false) launcher.focus({ preventScroll: true });
      track('live_chat_close');
    }

    function autoSizeInput() {
      input.style.height = 'auto';
      input.style.height = Math.min(input.scrollHeight, 108) + 'px';
    }

    function sendMessage(text) {
      var cleanText = String(text || '').trim();
      if (!cleanText || isSending || !apiUrl) return;
      isSending = true;
      sendButton.disabled = true;
      setStatus('Sending...', false);

      var optimisticId = 'sending_' + Date.now();
      messages.push({
        id: optimisticId,
        role: 'visitor',
        text: cleanText,
        createdAt: new Date().toISOString()
      });
      renderMessages(true);
      input.value = '';
      autoSizeInput();

      requestJson(apiUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          sessionId: sessionId,
          message: cleanText,
          pageUrl: window.location.href,
          pageTitle: document.title,
          referrer: document.referrer || '',
          shopDomain: window.location.hostname,
          website: ''
        })
      }).then(function (data) {
        isActive = true;
        safeStorageSet(activeKey, 'yes');
        syncMessages(data.messages, true);
        setStatus('Message sent.', false);
        track('live_chat_message_sent');
        connectSocket();
        schedulePoll(800);
      }).catch(function () {
        messages = messages.filter(function (message) {
          return message.id !== optimisticId;
        });
        renderMessages(true);
        input.value = cleanText;
        autoSizeInput();
        setStatus('Could not send. Check your connection and try again.', true);
      }).finally(function () {
        isSending = false;
        sendButton.disabled = false;
      });
    }

    function isVisible(element) {
      if (!element || !element.getBoundingClientRect) return false;
      var style = window.getComputedStyle(element);
      var rect = element.getBoundingClientRect();
      return style.display !== 'none'
        && style.visibility !== 'hidden'
        && Number(style.opacity || 1) > 0.05
        && rect.width > 2
        && rect.height > 2;
    }

    function visibleKlaviyoPopup() {
      var popup = document.querySelector('[aria-label="POPUP Form"]');
      return isVisible(popup) ? popup : null;
    }

    function updateCollision() {
      collisionFrame = 0;
      var ageGateActive = document.body.classList.contains('bd-age-gate-active');
      var menuOpen = Boolean(document.querySelector('.site-header.is-menu-open'));
      var popupOpen = Boolean(visibleKlaviyoPopup());
      var viewportHeight = window.innerHeight || document.documentElement.clientHeight || 0;
      var isMobile = window.innerWidth <= 640;
      var homepageHero = document.querySelector('.home-social-hero');
      var homepageHeroIsPrimary = false;

      if (isMobile && isVisible(homepageHero)) {
        var homepageHeroRect = homepageHero.getBoundingClientRect();
        homepageHeroIsPrimary = homepageHeroRect.top < 120
          && homepageHeroRect.bottom > viewportHeight * 0.78;
      }

      if ((ageGateActive || menuOpen) && isOpen) closeChat(false);
      root.classList.toggle(
        'is-suppressed',
        ageGateActive || menuOpen || (popupOpen && !isOpen) || (homepageHeroIsPrimary && !isOpen)
      );

      if (isOpen) {
        root.style.setProperty('--bd-chat-bottom', 'max(18px, env(safe-area-inset-bottom))');
        return;
      }

      var bottom = isMobile ? 14 : 18;
      var stickyCta = document.querySelector('.bd-sticky-shop');
      if (isMobile && isVisible(stickyCta)) {
        var stickyRect = stickyCta.getBoundingClientRect();
        bottom = Math.max(bottom, Math.ceil(viewportHeight - stickyRect.top + 10));
      }

      var launcherWidth = launcher.offsetWidth || 220;
      var launcherHeight = launcher.offsetHeight || 58;
      var launcherRight = window.innerWidth - (isMobile ? 10 : 18);
      var launcherLeft = launcherRight - launcherWidth;
      var launcherTop = viewportHeight - bottom - launcherHeight;
      var purchaseCta = document.querySelector(
        '#BuzzDropsProductForm > .button, .cart-summary .checkout-button'
      );
      if (isVisible(purchaseCta)) {
        var purchaseRect = purchaseCta.getBoundingClientRect();
        var overlapsLauncher = purchaseRect.right > launcherLeft - 8
          && purchaseRect.left < launcherRight + 8
          && purchaseRect.bottom > launcherTop - 8
          && purchaseRect.top < launcherTop + launcherHeight + 8;
        if (overlapsLauncher) {
          bottom = Math.max(bottom, Math.ceil(viewportHeight - purchaseRect.top + 10));
        }
      }

      var teaser = isMobile ? document.querySelector('[class*="kl-teaser-"]') : null;
      if (isVisible(teaser)) {
        var teaserRect = teaser.getBoundingClientRect();
        if (teaserRect.right > launcherLeft - 8) {
          bottom = Math.max(bottom, Math.ceil(viewportHeight - teaserRect.top + 10));
        }
      }

      root.style.setProperty('--bd-chat-bottom', 'max(' + bottom + 'px, env(safe-area-inset-bottom))');
    }

    function scheduleCollisionUpdate() {
      if (collisionFrame) return;
      collisionFrame = window.requestAnimationFrame(updateCollision);
    }

    launcher.addEventListener('click', openChat);
    closeButton.addEventListener('click', function () { closeChat(true); });
    form.addEventListener('submit', function (event) {
      event.preventDefault();
      sendMessage(input.value);
    });
    input.addEventListener('input', autoSizeInput);
    input.addEventListener('keydown', function (event) {
      if (event.key === 'Enter' && !event.shiftKey && !event.isComposing) {
        event.preventDefault();
        form.requestSubmit();
      }
    });
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && isOpen) closeChat(true);
    });
    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'visible' && isActive) {
        connectSocket();
        fetchHistory();
        schedulePoll(nextPollDelay());
      }
    });
    window.addEventListener('resize', scheduleCollisionUpdate, { passive: true });
    window.addEventListener('scroll', scheduleCollisionUpdate, { passive: true });

    if (window.MutationObserver && document.body) {
      new MutationObserver(scheduleCollisionUpdate).observe(document.body, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['class', 'style', 'aria-hidden', 'hidden']
      });
    }

    renderMessages(false);
    updateCollision();
    if (isActive) {
      connectSocket();
      fetchHistory();
      schedulePoll(3200);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initBuzzDropsLiveChat, { once: true });
  } else {
    initBuzzDropsLiveChat();
  }
})();
